import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BhelLogo from '../../assets/icons/bhel-logo.svg';
import ActiveStepIcon from '../../assets/icons/active-step-icon.svg';
import InactiveStepIcon from '../../assets/icons/inactive-step-icon.svg';
import StepperConnectingLine from '../../assets/icons/stepper-connecting-line.svg';
import { setActiveStep } from '../../redux/budgetSlice/budgetSlice';

const steps = [
        { label: 'Project Cost', step: 1 },
        { label: 'Apportioned Cost', step: 2 },
        { label: 'Operational Income', step: 3 },
        { label: 'Billing', step: 4 },
        { label: 'Cash Flow', step: 5 },
        { label: 'Upload Files', step: 6 },
        { label: 'Final Preview', step: 7 },
];

const Stepper = () => {
        const activeStep = useSelector((state) => state.budget.activeStep);
        const dispatch = useDispatch();

        return (
                <div className="w-[100%] bg-[#FFFFFF] flex flex-col pt-4">
                        <div className="px-4 py-8">
                                <img
                                        src={BhelLogo}
                                        alt="bhel logo"
                                        className="w-16 h-[52px]"
                                />
                        </div>
                        <div className="relative">
                                {steps.map(({ label, step }) => {
                                        const isActive = step === activeStep;
                                        return (
                                                <div
                                                        key={step}
                                                        className={`py-2.5 pl-2.5 flex gap-1 cursor-pointer ${
                                                                isActive
                                                                        ? 'bg-[#2C3F7E] text-white'
                                                                        : 'text-black'
                                                        }`}
                                                        onClick={() => {
                                                                // if (step <= activeStep) {
                                                                        dispatch(
                                                                                setActiveStep(step),
                                                                        );
                                                                // }
                                                        }}
                                                >
                                                        <img
                                                                src={
                                                                        isActive
                                                                                ? ActiveStepIcon
                                                                                : InactiveStepIcon
                                                                }
                                                                alt={`Step ${step}`}
                                                                className="z-10"
                                                        />
                                                        <div className="flex flex-col gap-1">
                                                                <div
                                                                        className={`font-medium text-[12px] leading-[18px] tracking-[0.15px] ${
                                                                                isActive
                                                                                        ? 'text-white'
                                                                                        : 'text-black'
                                                                        }`}
                                                                >
                                                                        {label}
                                                                </div>
                                                                <div
                                                                        className={`font-medium text-[10px] leading-[15px] tracking-[0.15px]  ${
                                                                                isActive
                                                                                        ? 'text-white'
                                                                                        : 'text-[#7B7C7F]'
                                                                        }`}
                                                                >
                                                                        Step {step}
                                                                </div>
                                                        </div>
                                                </div>
                                        );
                                })}
                                <div className="absolute top-1 left-[22px] flex items-center">
                                        <img
                                                src={StepperConnectingLine}
                                                alt="line"
                                                className="h-[380px] w-auto"
                                        />
                                </div>
                        </div>
                </div>
        );
};

export default Stepper;
